__turbopack_context__.v({
  "bestTimeSelectContainer": "ndvpIq_bestTimeSelectContainer",
  "checkbox": "ndvpIq_checkbox",
  "checkboxContainer": "ndvpIq_checkboxContainer",
  "checkboxLabel": "ndvpIq_checkboxLabel",
  "comments": "ndvpIq_comments",
  "commentsContainer": "ndvpIq_commentsContainer",
  "emptyColumn": "ndvpIq_emptyColumn",
  "inputError": "ndvpIq_inputError",
  "isCentered": "ndvpIq_isCentered",
  "modalBackdrop": "ndvpIq_modalBackdrop",
  "modalCloseButton": "ndvpIq_modalCloseButton",
  "modalColumnOne": "ndvpIq_modalColumnOne",
  "modalColumnTwo": "ndvpIq_modalColumnTwo",
  "modalContainer": "ndvpIq_modalContainer",
  "modalForm": "ndvpIq_modalForm",
  "modalHeader": "ndvpIq_modalHeader",
  "modalHeaderContainer": "ndvpIq_modalHeaderContainer",
  "modalInput": "ndvpIq_modalInput",
  "modalSelectInput": "ndvpIq_modalSelectInput",
  "modalSelectWrapper": "ndvpIq_modalSelectWrapper",
  "selectLabel": "ndvpIq_selectLabel",
  "submitButtonContainer": "ndvpIq_submitButtonContainer",
  "submitContainer": "ndvpIq_submitContainer",
  "white": "ndvpIq_white",
});
